'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
//  Header
var toggle = document.querySelectorAll('.toggle-action');
var body = document.body;
function headerToggle() {
    if (body.classList.contains('_menu-open')) body.classList.remove('_menu-open');
    else body.classList.add('_menu-open');
}
toggle.forEach(function(item) {
    item.addEventListener('click', headerToggle);
});
// Scroll btn
var btnTop = document.querySelector('.scroll-top');
btnTop.addEventListener('click', scrollTop);
function scrollTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
// Form
var form = document.querySelector('#form');
form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = form.email.value.trim();
    if (!email) return false;
    form.email.value = '';
    scrollTop();
});
// Gallery
var gallery = document.querySelector('.gallery__container');
var dots = document.querySelector('.gallery__dots');
_to_consumable_array(gallery.children).forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.classList.add('gallery__dot');
    dot.addEventListener('click', function() {
        gallery.scrollTo({
            left: gallery.offsetWidth * i,
            behavior: 'smooth'
        });
    });
    dots.append(dot);
});

//# sourceMappingURL=Museum.5939268c.js.map
